import * as React from 'react';
import { ChartDataContext } from "../context/Chart";
import { Spinner } from "./Spinner";

export type SegmentAveragesProps = {
    filter_id: string;
}

export const SegmentAverages = (props: SegmentAveragesProps): JSX.Element => {
    const [chartdata,] = React.useContext(ChartDataContext);

    if (chartdata.result_set === undefined) {
        return <></>
    }

    const segmentResults = chartdata.result_set.filter((result) => result.filter_id === props.filter_id);

    if (chartdata.fetching) {
        return <Spinner title={'Bezig met het ophalen van de gegevens'} />;
    }

    return <div className={'c-rstats__segment__averages'}>
        {segmentResults.map((result) => {

            return <div key={result.title} className={'c-rstats__segment__average'}>
                <h5>{result.title}</h5>
                {result.passed_threshold ?
                    (<dl>
                        <dt>Aantal respondenten</dt>
                        <dd>{result.average_score.response_count}</dd>
                        <dt>Gemiddelde score</dt>
                        <dd>{(result.average_score.average / 10).toFixed(1)}</dd>
                    </dl>) : (
                        <div className={'c-rstats__loading'}>Niet voldoende respondenten voor deze periode</div>
                    )}
            </div>

        })}
    </div>;
}
